<template>
  <b-container>
    <b-row cols="2">
      <b-col class="pb-4" v-for="(image) in images" v-bind:key="image.id" >
        <div 
          class="image-col p-2"
          :class="{'selected': selected == image.id}"
          @click="setAsset(image)"
        >
          <b-img 
            thumbnail 
            fluid 
            :src="image.signed_url" alt="Image 1" 
          />
          <div class="text-center small py-1">{{ extractName(image.name) }}</div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

import { mapGetters, mapState } from 'vuex'
export default {
  name: "AssetsListDrawer",
  data(){
    return {
      loading: false,
      defaultFields: {},
      draggable: false,
      prevSectionId: null
    }
  },
  mounted(){
  },

  computed: {
    ...mapState(['sections']),
    ...mapGetters({
      images: 'assets/assetDetails',
      image: 'assets/assetDetail'
    }),

    selected(){
      return this.image.id;
    },

    section: function() {
      return (this.sections.item)
    },

    isEquipment: function(){
      return (this.section.section_type == 'equipment')
    },

    equipment: function(){
      return this.section.equipment_detail.equipment_config
    },

    fields: function(){
      if((this.section.equipment_detail || {}).data){
        return this.section.equipment_detail.data
      } else {
        return this.defaultFields
      }
    },

  },
 
  watch: {
    section: function(val1){
      if(val1.id != this.prevSectionId){
        this.draggable = false
      }
      this.prevSectionId = val1.id
    }
  },
  
  methods: {
    extractName(name){
      let temp = name.split('/')
      return temp[temp.length-1].replace(/\.jpg|\.jpeg|\.png/g,"")
    },
    setAsset(image){
      this.$store.commit('assets/ASSET_DETAIL', image)
    }
  }
  
}
</script>
<style>
.image-col{
  transition: all .2s;
}
.image-col:hover, .image-col.selected{
  cursor:pointer;
  scale: 1.07;
}
.image-col:hover img, .image-col.selected img{
  outline: 2px solid #42b983;
}
</style>

